app.mediator.registerModule(MODULE_NAME__NEWSLETTER_FOOTER_CTA, function (app) {

    var helpers = app.helpers.funcs;

    return {

        $rootElem: null,
        hidden: false,

        //==========================================================xdiv2====
        // Start and stop
        //===================================================================

        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },

        init: function () {
            this.$rootElem = $('.mod-newsletter-footer-cta');
            if (!this.$rootElem.length) return;
            this.addMediatorListeners();
        },

        addMediatorListeners: function () {
            var scope = this;
            app.mediator.addListener(EVENT_NAME__GALLERY__GALLERY_WITH_INFINITE_SCROLL_INITIATED, function () {
                // If the page has an infinite scroll gallery, we want to hide the footer,
                // until we have reached the last of the gallery items.
                scope.hide();
            });

            app.mediator.addListener(EVENT_NAME__GALLERY__BOTTOM_OF_INFINITE_SCROLL_REACHED, function () {
                scope.show();
            });

            app.mediator.addListener(EVENT_NAME__NEWSLETTER_FLASH_CTA__BUTTON_CLICKED, function (data) {
                var offset = (data.barWasStickyWhenButtonWasClicked) ? 0 : -70;
                scope.scrollToTopOfModule(offset);
            });
        },

        //==========================================================xdiv2====
        // Module
        //===================================================================

        hide: function () {
            this.$rootElem.addClass('hidden');
            this.hidden = true;
        },

        show: function () {
            this.$rootElem.removeClass('hidden');
            this.hidden = false;
        },

        scrollToTopOfModule: function (offset) {
            var scope = this;
            offset = typeof offset !== 'undefined' ? parseInt(offset) : 0;
            var topOffset = this.$rootElem.offset().top - 68 + offset;
            $('body,html').stop().animate({
                scrollTop: topOffset
            }, function () {
                scope.$rootElem.find('input[type=email]').focus();
            });
        }

    };
});